export default __webpack_public_path__ + "static/media/houimg6.6f562e1c.webp";